//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/";
    }

    /**
     * @return OK
     */
    getLoggedUserProfile(): Observable<void> {
        let url_ = this.baseUrl + "/api/Account/get-logged-user-profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetLoggedUserProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLoggedUserProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetLoggedUserProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getLoginProfileInfo(): Observable<void> {
        let url_ = this.baseUrl + "/api/Account/get-login-profile-info";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetLoginProfileInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLoginProfileInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetLoginProfileInfo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    isPartnerPortalDigitalArchiveEnabled(): Observable<FeatureToggleResponse> {
        let url_ = this.baseUrl + "/api/Account/is-partner-portal-digital-archive-enabled";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processIsPartnerPortalDigitalArchiveEnabled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsPartnerPortalDigitalArchiveEnabled(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FeatureToggleResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FeatureToggleResponse>;
        }));
    }

    protected processIsPartnerPortalDigitalArchiveEnabled(response: HttpResponseBase): Observable<FeatureToggleResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = FeatureToggleResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    isWebpayEnabled(): Observable<FeatureToggleResponse> {
        let url_ = this.baseUrl + "/api/Account/is-webpay-enabled";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processIsWebpayEnabled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsWebpayEnabled(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FeatureToggleResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FeatureToggleResponse>;
        }));
    }

    protected processIsWebpayEnabled(response: HttpResponseBase): Observable<FeatureToggleResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = FeatureToggleResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    hasPersonalInformationCompleted(): Observable<HasPersonalInformation> {
        let url_ = this.baseUrl + "/api/Account/has-personal-information-completed";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processHasPersonalInformationCompleted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasPersonalInformationCompleted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HasPersonalInformation>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HasPersonalInformation>;
        }));
    }

    protected processHasPersonalInformationCompleted(response: HttpResponseBase): Observable<HasPersonalInformation> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = HasPersonalInformation.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    completePersonalInformation(body: PersonalInformationRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/Account/complete-personal-information";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCompletePersonalInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompletePersonalInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCompletePersonalInformation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = UpdatedPersonalInformationResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class G11nClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/";
    }

    /**
     * @param culture (optional) 
     * @return OK
     */
    translations(culture: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/G11n/translations?";
        if (culture === null)
            throw new globalThis.Error("The parameter 'culture' cannot be null.");
        else if (culture !== undefined)
            url_ += "culture=" + encodeURIComponent("" + culture) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processTranslations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTranslations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTranslations(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    availableLangs(): Observable<void> {
        let url_ = this.baseUrl + "/api/G11n/available-langs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processAvailableLangs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAvailableLangs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAvailableLangs(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ServerInfoClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/";
    }

    /**
     * @return OK
     */
    getServerInfo(): Observable<void> {
        let url_ = this.baseUrl + "/api/ServerInfo/get-server-info";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetServerInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServerInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetServerInfo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BavelPayTravelClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/";
    }

    /**
     * @param dateFilter (optional) 
     * @param start (optional) 
     * @param end (optional) 
     * @param referenceFilter (optional) 
     * @param reference (optional) 
     * @param payerId (optional) 
     * @param payeeId (optional) 
     * @param pager_currentPage (optional) 
     * @param pager_pageSize (optional) 
     * @param statusFilter (optional) 
     * @return OK
     */
    bavelPayTravelGET(dateFilter: number | undefined, start: Date | undefined, end: Date | undefined, referenceFilter: number | undefined, reference: string | undefined, payerId: number | undefined, payeeId: string | undefined, pager_currentPage: number | undefined, pager_pageSize: number | undefined, statusFilter: number | undefined): Observable<BavelPayTravelSearchResult> {
        let url_ = this.baseUrl + "/api/BavelPayTravel?";
        if (dateFilter === null)
            throw new globalThis.Error("The parameter 'dateFilter' cannot be null.");
        else if (dateFilter !== undefined)
            url_ += "dateFilter=" + encodeURIComponent("" + dateFilter) + "&";
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new globalThis.Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (referenceFilter === null)
            throw new globalThis.Error("The parameter 'referenceFilter' cannot be null.");
        else if (referenceFilter !== undefined)
            url_ += "referenceFilter=" + encodeURIComponent("" + referenceFilter) + "&";
        if (reference === null)
            throw new globalThis.Error("The parameter 'reference' cannot be null.");
        else if (reference !== undefined)
            url_ += "reference=" + encodeURIComponent("" + reference) + "&";
        if (payerId === null)
            throw new globalThis.Error("The parameter 'payerId' cannot be null.");
        else if (payerId !== undefined)
            url_ += "payerId=" + encodeURIComponent("" + payerId) + "&";
        if (payeeId === null)
            throw new globalThis.Error("The parameter 'payeeId' cannot be null.");
        else if (payeeId !== undefined)
            url_ += "payeeId=" + encodeURIComponent("" + payeeId) + "&";
        if (pager_currentPage === null)
            throw new globalThis.Error("The parameter 'pager_currentPage' cannot be null.");
        else if (pager_currentPage !== undefined)
            url_ += "pager.currentPage=" + encodeURIComponent("" + pager_currentPage) + "&";
        if (pager_pageSize === null)
            throw new globalThis.Error("The parameter 'pager_pageSize' cannot be null.");
        else if (pager_pageSize !== undefined)
            url_ += "pager.pageSize=" + encodeURIComponent("" + pager_pageSize) + "&";
        if (statusFilter === null)
            throw new globalThis.Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "statusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBavelPayTravelGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBavelPayTravelGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BavelPayTravelSearchResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BavelPayTravelSearchResult>;
        }));
    }

    protected processBavelPayTravelGET(response: HttpResponseBase): Observable<BavelPayTravelSearchResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BavelPayTravelSearchResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;

                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = ProblemDetails.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    bavelPayTravelPUT(body: BavelPayTravelUpdateRequest): Observable<BavelPayTravelUpdateResponse> {
        let url_ = this.baseUrl + "/api/BavelPayTravel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBavelPayTravelPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBavelPayTravelPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BavelPayTravelUpdateResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BavelPayTravelUpdateResponse>;
        }));
    }

    protected processBavelPayTravelPUT(response: HttpResponseBase): Observable<BavelPayTravelUpdateResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BavelPayTravelUpdateResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    bavelPayTravelDELETE(body: BavelPayTravelDeleteRequest): Observable<BavelPayTravelDeleteResponse> {
        let url_ = this.baseUrl + "/api/BavelPayTravel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBavelPayTravelDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBavelPayTravelDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BavelPayTravelDeleteResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BavelPayTravelDeleteResponse>;
        }));
    }

    protected processBavelPayTravelDELETE(response: HttpResponseBase): Observable<BavelPayTravelDeleteResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BavelPayTravelDeleteResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param piid (optional) 
     * @return OK
     */
    getPaymentDetails(piid: string | undefined): Observable<PaymentDetailResponse> {
        let url_ = this.baseUrl + "/api/BavelPayTravel/get-payment-details?";
        if (piid === null)
            throw new globalThis.Error("The parameter 'piid' cannot be null.");
        else if (piid !== undefined)
            url_ += "piid=" + encodeURIComponent("" + piid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPaymentDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentDetailResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentDetailResponse>;
        }));
    }

    protected processGetPaymentDetails(response: HttpResponseBase): Observable<PaymentDetailResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaymentDetailResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param piid (optional) 
     * @return OK
     */
    getNotifications(piid: string | undefined): Observable<PaymentNotifications> {
        let url_ = this.baseUrl + "/api/BavelPayTravel/get-notifications?";
        if (piid === null)
            throw new globalThis.Error("The parameter 'piid' cannot be null.");
        else if (piid !== undefined)
            url_ += "piid=" + encodeURIComponent("" + piid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentNotifications>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentNotifications>;
        }));
    }

    protected processGetNotifications(response: HttpResponseBase): Observable<PaymentNotifications> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaymentNotifications.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param piid (optional) 
     * @return OK
     */
    getFullTrack(piid: string | undefined): Observable<FullTrack> {
        let url_ = this.baseUrl + "/api/BavelPayTravel/get-full-track?";
        if (piid === null)
            throw new globalThis.Error("The parameter 'piid' cannot be null.");
        else if (piid !== undefined)
            url_ += "piid=" + encodeURIComponent("" + piid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFullTrack(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFullTrack(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FullTrack>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FullTrack>;
        }));
    }

    protected processGetFullTrack(response: HttpResponseBase): Observable<FullTrack> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = FullTrack.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    resendPaymentNotification(body: NotificationRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/BavelPayTravel/resend-payment-notification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processResendPaymentNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendPaymentNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResendPaymentNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BavelPayTravelFiltersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/";
    }

    /**
     * @param payerId (optional) 
     * @return OK
     */
    bavelPayTravelFilters(payerId: number | undefined): Observable<BavelPayTravelFilter> {
        let url_ = this.baseUrl + "/api/BavelPayTravelFilters?";
        if (payerId === null)
            throw new globalThis.Error("The parameter 'payerId' cannot be null.");
        else if (payerId !== undefined)
            url_ += "payerId=" + encodeURIComponent("" + payerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBavelPayTravelFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBavelPayTravelFilters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BavelPayTravelFilter>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BavelPayTravelFilter>;
        }));
    }

    protected processBavelPayTravelFilters(response: HttpResponseBase): Observable<BavelPayTravelFilter> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BavelPayTravelFilter.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BavelPayTravelNewVccClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/";
    }

    /**
     * @return OK
     */
    getPartners(): Observable<VccPartner[]> {
        let url_ = this.baseUrl + "/api/BavelPayTravelNewVcc/get-partners";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPartners(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPartners(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VccPartner[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VccPartner[]>;
        }));
    }

    protected processGetPartners(response: HttpResponseBase): Observable<VccPartner[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(VccPartner.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param partnerId (optional) 
     * @return OK
     */
    getMoneyAccounts(partnerId: number | undefined): Observable<VccMoneyAccount[]> {
        let url_ = this.baseUrl + "/api/BavelPayTravelNewVcc/get-money-accounts?";
        if (partnerId === null)
            throw new globalThis.Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined)
            url_ += "partnerId=" + encodeURIComponent("" + partnerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMoneyAccounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMoneyAccounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VccMoneyAccount[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VccMoneyAccount[]>;
        }));
    }

    protected processGetMoneyAccounts(response: HttpResponseBase): Observable<VccMoneyAccount[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(VccMoneyAccount.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param moneyAccountId (optional) 
     * @return OK
     */
    getVccProfiles(moneyAccountId: string | undefined): Observable<VccProfile[]> {
        let url_ = this.baseUrl + "/api/BavelPayTravelNewVcc/get-vcc-profiles?";
        if (moneyAccountId === null)
            throw new globalThis.Error("The parameter 'moneyAccountId' cannot be null.");
        else if (moneyAccountId !== undefined)
            url_ += "moneyAccountId=" + encodeURIComponent("" + moneyAccountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetVccProfiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVccProfiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VccProfile[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VccProfile[]>;
        }));
    }

    protected processGetVccProfiles(response: HttpResponseBase): Observable<VccProfile[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(VccProfile.fromJS(item));
                }
                else {
                    result200 = null as any;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    bavelPayTravelNewVcc(body: BavelPayTravelNewVccCardRequest): Observable<BavelPayTravelNewVccResponse> {
        let url_ = this.baseUrl + "/api/BavelPayTravelNewVcc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBavelPayTravelNewVcc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBavelPayTravelNewVcc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BavelPayTravelNewVccResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BavelPayTravelNewVccResponse>;
        }));
    }

    protected processBavelPayTravelNewVcc(response: HttpResponseBase): Observable<BavelPayTravelNewVccResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BavelPayTravelNewVccResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BavelPayTravelReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/";
    }

    /**
     * @param dateFilter (optional) 
     * @param start (optional) 
     * @param end (optional) 
     * @param referenceFilter (optional) 
     * @param reference (optional) 
     * @param payerId (optional) 
     * @param payeeId (optional) 
     * @param pager_currentPage (optional) 
     * @param pager_pageSize (optional) 
     * @param statusFilter (optional) 
     * @return OK
     */
    bavelPayTravelReport(dateFilter: number | undefined, start: Date | undefined, end: Date | undefined, referenceFilter: number | undefined, reference: string | undefined, payerId: number | undefined, payeeId: string | undefined, pager_currentPage: number | undefined, pager_pageSize: number | undefined, statusFilter: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/BavelPayTravelReport?";
        if (dateFilter === null)
            throw new globalThis.Error("The parameter 'dateFilter' cannot be null.");
        else if (dateFilter !== undefined)
            url_ += "dateFilter=" + encodeURIComponent("" + dateFilter) + "&";
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new globalThis.Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (referenceFilter === null)
            throw new globalThis.Error("The parameter 'referenceFilter' cannot be null.");
        else if (referenceFilter !== undefined)
            url_ += "referenceFilter=" + encodeURIComponent("" + referenceFilter) + "&";
        if (reference === null)
            throw new globalThis.Error("The parameter 'reference' cannot be null.");
        else if (reference !== undefined)
            url_ += "reference=" + encodeURIComponent("" + reference) + "&";
        if (payerId === null)
            throw new globalThis.Error("The parameter 'payerId' cannot be null.");
        else if (payerId !== undefined)
            url_ += "payerId=" + encodeURIComponent("" + payerId) + "&";
        if (payeeId === null)
            throw new globalThis.Error("The parameter 'payeeId' cannot be null.");
        else if (payeeId !== undefined)
            url_ += "payeeId=" + encodeURIComponent("" + payeeId) + "&";
        if (pager_currentPage === null)
            throw new globalThis.Error("The parameter 'pager_currentPage' cannot be null.");
        else if (pager_currentPage !== undefined)
            url_ += "pager.currentPage=" + encodeURIComponent("" + pager_currentPage) + "&";
        if (pager_pageSize === null)
            throw new globalThis.Error("The parameter 'pager_pageSize' cannot be null.");
        else if (pager_pageSize !== undefined)
            url_ += "pager.pageSize=" + encodeURIComponent("" + pager_pageSize) + "&";
        if (statusFilter === null)
            throw new globalThis.Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "statusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/csv"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBavelPayTravelReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBavelPayTravelReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processBavelPayTravelReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BavelCollectTravelClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/";
    }

    /**
     * @param dateFilter (optional) 
     * @param start (optional) 
     * @param end (optional) 
     * @param referenceFilter (optional) 
     * @param reference (optional) 
     * @param payerId (optional) 
     * @param payeeId (optional) 
     * @param pager_currentPage (optional) 
     * @param pager_pageSize (optional) 
     * @param payeeEmail (optional) 
     * @param loginName (optional) 
     * @param alienetPayers (optional) 
     * @param statusFilter (optional) 
     * @param settlementInvoiceStatusDefaulter (optional) 
     * @return OK
     */
    bavelCollectTravel(dateFilter: number | undefined, start: Date | undefined, end: Date | undefined, referenceFilter: number | undefined, reference: string | undefined, payerId: string | undefined, payeeId: number | undefined, pager_currentPage: number | undefined, pager_pageSize: number | undefined, payeeEmail: string | undefined, loginName: string | undefined, alienetPayers: string[] | undefined, statusFilter: number | undefined, settlementInvoiceStatusDefaulter: boolean | undefined): Observable<BavelCollectTravelSearchResult> {
        let url_ = this.baseUrl + "/api/BavelCollectTravel?";
        if (dateFilter === null)
            throw new globalThis.Error("The parameter 'dateFilter' cannot be null.");
        else if (dateFilter !== undefined)
            url_ += "DateFilter=" + encodeURIComponent("" + dateFilter) + "&";
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "Start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new globalThis.Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "End=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (referenceFilter === null)
            throw new globalThis.Error("The parameter 'referenceFilter' cannot be null.");
        else if (referenceFilter !== undefined)
            url_ += "ReferenceFilter=" + encodeURIComponent("" + referenceFilter) + "&";
        if (reference === null)
            throw new globalThis.Error("The parameter 'reference' cannot be null.");
        else if (reference !== undefined)
            url_ += "Reference=" + encodeURIComponent("" + reference) + "&";
        if (payerId === null)
            throw new globalThis.Error("The parameter 'payerId' cannot be null.");
        else if (payerId !== undefined)
            url_ += "PayerId=" + encodeURIComponent("" + payerId) + "&";
        if (payeeId === null)
            throw new globalThis.Error("The parameter 'payeeId' cannot be null.");
        else if (payeeId !== undefined)
            url_ += "PayeeId=" + encodeURIComponent("" + payeeId) + "&";
        if (pager_currentPage === null)
            throw new globalThis.Error("The parameter 'pager_currentPage' cannot be null.");
        else if (pager_currentPage !== undefined)
            url_ += "Pager.currentPage=" + encodeURIComponent("" + pager_currentPage) + "&";
        if (pager_pageSize === null)
            throw new globalThis.Error("The parameter 'pager_pageSize' cannot be null.");
        else if (pager_pageSize !== undefined)
            url_ += "Pager.pageSize=" + encodeURIComponent("" + pager_pageSize) + "&";
        if (payeeEmail === null)
            throw new globalThis.Error("The parameter 'payeeEmail' cannot be null.");
        else if (payeeEmail !== undefined)
            url_ += "PayeeEmail=" + encodeURIComponent("" + payeeEmail) + "&";
        if (loginName === null)
            throw new globalThis.Error("The parameter 'loginName' cannot be null.");
        else if (loginName !== undefined)
            url_ += "LoginName=" + encodeURIComponent("" + loginName) + "&";
        if (alienetPayers === null)
            throw new globalThis.Error("The parameter 'alienetPayers' cannot be null.");
        else if (alienetPayers !== undefined)
            alienetPayers && alienetPayers.forEach(item => { url_ += "AlienetPayers=" + encodeURIComponent("" + item) + "&"; });
        if (statusFilter === null)
            throw new globalThis.Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (settlementInvoiceStatusDefaulter === null)
            throw new globalThis.Error("The parameter 'settlementInvoiceStatusDefaulter' cannot be null.");
        else if (settlementInvoiceStatusDefaulter !== undefined)
            url_ += "SettlementInvoiceStatusDefaulter=" + encodeURIComponent("" + settlementInvoiceStatusDefaulter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBavelCollectTravel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBavelCollectTravel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BavelCollectTravelSearchResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BavelCollectTravelSearchResult>;
        }));
    }

    protected processBavelCollectTravel(response: HttpResponseBase): Observable<BavelCollectTravelSearchResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BavelCollectTravelSearchResult.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;

                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = ProblemDetails.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    isDefaulterPayee(): Observable<DefaulterPayeeResponse> {
        let url_ = this.baseUrl + "/api/BavelCollectTravel/is-defaulter-payee";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processIsDefaulterPayee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsDefaulterPayee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DefaulterPayeeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DefaulterPayeeResponse>;
        }));
    }

    protected processIsDefaulterPayee(response: HttpResponseBase): Observable<DefaulterPayeeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DefaulterPayeeResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = ProblemDetails.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result500: any = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = resultData500 !== undefined ? resultData500 : null as any;

                return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param piid (optional) 
     * @return OK
     */
    getFullTrack2(piid: string | undefined): Observable<FullTrack> {
        let url_ = this.baseUrl + "/api/BavelCollectTravel/get-full-track?";
        if (piid === null)
            throw new globalThis.Error("The parameter 'piid' cannot be null.");
        else if (piid !== undefined)
            url_ += "piid=" + encodeURIComponent("" + piid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFullTrack2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFullTrack2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FullTrack>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FullTrack>;
        }));
    }

    protected processGetFullTrack2(response: HttpResponseBase): Observable<FullTrack> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = FullTrack.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param piid (optional) 
     * @return OK
     */
    getPaymentDetails2(piid: string | undefined): Observable<PaymentDetailResponse> {
        let url_ = this.baseUrl + "/api/BavelCollectTravel/get-payment-details?";
        if (piid === null)
            throw new globalThis.Error("The parameter 'piid' cannot be null.");
        else if (piid !== undefined)
            url_ += "piid=" + encodeURIComponent("" + piid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPaymentDetails2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentDetails2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentDetailResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentDetailResponse>;
        }));
    }

    protected processGetPaymentDetails2(response: HttpResponseBase): Observable<PaymentDetailResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaymentDetailResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BavelCollectTravelFiltersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/";
    }

    /**
     * @param payeeId (optional) 
     * @return OK
     */
    bavelCollectTravelFilters(payeeId: number | undefined): Observable<BavelCollectTravelFilter> {
        let url_ = this.baseUrl + "/api/BavelCollectTravelFilters?";
        if (payeeId === null)
            throw new globalThis.Error("The parameter 'payeeId' cannot be null.");
        else if (payeeId !== undefined)
            url_ += "payeeId=" + encodeURIComponent("" + payeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBavelCollectTravelFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBavelCollectTravelFilters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BavelCollectTravelFilter>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BavelCollectTravelFilter>;
        }));
    }

    protected processBavelCollectTravelFilters(response: HttpResponseBase): Observable<BavelCollectTravelFilter> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BavelCollectTravelFilter.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BavelCollectTravelReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/";
    }

    /**
     * @param dateFilter (optional) 
     * @param start (optional) 
     * @param end (optional) 
     * @param referenceFilter (optional) 
     * @param reference (optional) 
     * @param payerId (optional) 
     * @param payeeId (optional) 
     * @param pager_currentPage (optional) 
     * @param pager_pageSize (optional) 
     * @param payeeEmail (optional) 
     * @param loginName (optional) 
     * @param alienetPayers (optional) 
     * @param statusFilter (optional) 
     * @param settlementInvoiceStatusDefaulter (optional) 
     * @return OK
     */
    bavelCollectTravelReport(dateFilter: number | undefined, start: Date | undefined, end: Date | undefined, referenceFilter: number | undefined, reference: string | undefined, payerId: string | undefined, payeeId: number | undefined, pager_currentPage: number | undefined, pager_pageSize: number | undefined, payeeEmail: string | undefined, loginName: string | undefined, alienetPayers: string[] | undefined, statusFilter: number | undefined, settlementInvoiceStatusDefaulter: boolean | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/BavelCollectTravelReport?";
        if (dateFilter === null)
            throw new globalThis.Error("The parameter 'dateFilter' cannot be null.");
        else if (dateFilter !== undefined)
            url_ += "DateFilter=" + encodeURIComponent("" + dateFilter) + "&";
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "Start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new globalThis.Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "End=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (referenceFilter === null)
            throw new globalThis.Error("The parameter 'referenceFilter' cannot be null.");
        else if (referenceFilter !== undefined)
            url_ += "ReferenceFilter=" + encodeURIComponent("" + referenceFilter) + "&";
        if (reference === null)
            throw new globalThis.Error("The parameter 'reference' cannot be null.");
        else if (reference !== undefined)
            url_ += "Reference=" + encodeURIComponent("" + reference) + "&";
        if (payerId === null)
            throw new globalThis.Error("The parameter 'payerId' cannot be null.");
        else if (payerId !== undefined)
            url_ += "PayerId=" + encodeURIComponent("" + payerId) + "&";
        if (payeeId === null)
            throw new globalThis.Error("The parameter 'payeeId' cannot be null.");
        else if (payeeId !== undefined)
            url_ += "PayeeId=" + encodeURIComponent("" + payeeId) + "&";
        if (pager_currentPage === null)
            throw new globalThis.Error("The parameter 'pager_currentPage' cannot be null.");
        else if (pager_currentPage !== undefined)
            url_ += "Pager.currentPage=" + encodeURIComponent("" + pager_currentPage) + "&";
        if (pager_pageSize === null)
            throw new globalThis.Error("The parameter 'pager_pageSize' cannot be null.");
        else if (pager_pageSize !== undefined)
            url_ += "Pager.pageSize=" + encodeURIComponent("" + pager_pageSize) + "&";
        if (payeeEmail === null)
            throw new globalThis.Error("The parameter 'payeeEmail' cannot be null.");
        else if (payeeEmail !== undefined)
            url_ += "PayeeEmail=" + encodeURIComponent("" + payeeEmail) + "&";
        if (loginName === null)
            throw new globalThis.Error("The parameter 'loginName' cannot be null.");
        else if (loginName !== undefined)
            url_ += "LoginName=" + encodeURIComponent("" + loginName) + "&";
        if (alienetPayers === null)
            throw new globalThis.Error("The parameter 'alienetPayers' cannot be null.");
        else if (alienetPayers !== undefined)
            alienetPayers && alienetPayers.forEach(item => { url_ += "AlienetPayers=" + encodeURIComponent("" + item) + "&"; });
        if (statusFilter === null)
            throw new globalThis.Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (settlementInvoiceStatusDefaulter === null)
            throw new globalThis.Error("The parameter 'settlementInvoiceStatusDefaulter' cannot be null.");
        else if (settlementInvoiceStatusDefaulter !== undefined)
            url_ += "SettlementInvoiceStatusDefaulter=" + encodeURIComponent("" + settlementInvoiceStatusDefaulter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/csv"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBavelCollectTravelReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBavelCollectTravelReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processBavelCollectTravelReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class BavelCollectTravelFilter implements IBavelCollectTravelFilter {
    dateFilter?: FilterItem[] | undefined;
    referenceFilter?: FilterItem[] | undefined;
    payerFilter?: StringFilterItem[] | undefined;
    statusFilter?: StatusFilterItem[] | undefined;

    [key: string]: any;

    constructor(data?: IBavelCollectTravelFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["dateFilter"])) {
                this.dateFilter = [] as any;
                for (let item of _data["dateFilter"])
                    this.dateFilter!.push(FilterItem.fromJS(item));
            }
            if (Array.isArray(_data["referenceFilter"])) {
                this.referenceFilter = [] as any;
                for (let item of _data["referenceFilter"])
                    this.referenceFilter!.push(FilterItem.fromJS(item));
            }
            if (Array.isArray(_data["payerFilter"])) {
                this.payerFilter = [] as any;
                for (let item of _data["payerFilter"])
                    this.payerFilter!.push(StringFilterItem.fromJS(item));
            }
            if (Array.isArray(_data["statusFilter"])) {
                this.statusFilter = [] as any;
                for (let item of _data["statusFilter"])
                    this.statusFilter!.push(StatusFilterItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BavelCollectTravelFilter {
        data = typeof data === 'object' ? data : {};
        let result = new BavelCollectTravelFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.dateFilter)) {
            data["dateFilter"] = [];
            for (let item of this.dateFilter)
                data["dateFilter"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.referenceFilter)) {
            data["referenceFilter"] = [];
            for (let item of this.referenceFilter)
                data["referenceFilter"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.payerFilter)) {
            data["payerFilter"] = [];
            for (let item of this.payerFilter)
                data["payerFilter"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.statusFilter)) {
            data["statusFilter"] = [];
            for (let item of this.statusFilter)
                data["statusFilter"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBavelCollectTravelFilter {
    dateFilter?: FilterItem[] | undefined;
    referenceFilter?: FilterItem[] | undefined;
    payerFilter?: StringFilterItem[] | undefined;
    statusFilter?: StatusFilterItem[] | undefined;

    [key: string]: any;
}

export class BavelCollectTravelItem implements IBavelCollectTravelItem {
    id?: string | undefined;
    formOfPayment?: FormOfPayment;
    status?: PaymentStatus;
    currency?: string | undefined;
    amount?: number;
    payerName?: string | undefined;
    effectiveDate?: Date;
    viewed?: boolean;
    bookings?: Booking[] | undefined;
    invoices?: Invoice[] | undefined;
    billBackRequestId?: string | undefined;
    settlementInvoiceStatus?: SettlementInvoiceStatus;

    [key: string]: any;

    constructor(data?: IBavelCollectTravelItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.formOfPayment = _data["formOfPayment"];
            this.status = _data["status"];
            this.currency = _data["currency"];
            this.amount = _data["amount"];
            this.payerName = _data["payerName"];
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : undefined as any;
            this.viewed = _data["viewed"];
            if (Array.isArray(_data["bookings"])) {
                this.bookings = [] as any;
                for (let item of _data["bookings"])
                    this.bookings!.push(Booking.fromJS(item));
            }
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices!.push(Invoice.fromJS(item));
            }
            this.billBackRequestId = _data["billBackRequestId"];
            this.settlementInvoiceStatus = _data["settlementInvoiceStatus"];
        }
    }

    static fromJS(data: any): BavelCollectTravelItem {
        data = typeof data === 'object' ? data : {};
        let result = new BavelCollectTravelItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["formOfPayment"] = this.formOfPayment;
        data["status"] = this.status;
        data["currency"] = this.currency;
        data["amount"] = this.amount;
        data["payerName"] = this.payerName;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : undefined as any;
        data["viewed"] = this.viewed;
        if (Array.isArray(this.bookings)) {
            data["bookings"] = [];
            for (let item of this.bookings)
                data["bookings"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item ? item.toJSON() : undefined as any);
        }
        data["billBackRequestId"] = this.billBackRequestId;
        data["settlementInvoiceStatus"] = this.settlementInvoiceStatus;
        return data;
    }
}

export interface IBavelCollectTravelItem {
    id?: string | undefined;
    formOfPayment?: FormOfPayment;
    status?: PaymentStatus;
    currency?: string | undefined;
    amount?: number;
    payerName?: string | undefined;
    effectiveDate?: Date;
    viewed?: boolean;
    bookings?: Booking[] | undefined;
    invoices?: Invoice[] | undefined;
    billBackRequestId?: string | undefined;
    settlementInvoiceStatus?: SettlementInvoiceStatus;

    [key: string]: any;
}

export class BavelCollectTravelSearchResult implements IBavelCollectTravelSearchResult {
    data?: BavelCollectTravelItem[] | undefined;
    total?: number;

    [key: string]: any;

    constructor(data?: IBavelCollectTravelSearchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(BavelCollectTravelItem.fromJS(item));
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): BavelCollectTravelSearchResult {
        data = typeof data === 'object' ? data : {};
        let result = new BavelCollectTravelSearchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["total"] = this.total;
        return data;
    }
}

export interface IBavelCollectTravelSearchResult {
    data?: BavelCollectTravelItem[] | undefined;
    total?: number;

    [key: string]: any;
}

export class BavelPayTravelDeleteRequest implements IBavelPayTravelDeleteRequest {
    piid?: string;
    senderId?: string | undefined;

    [key: string]: any;

    constructor(data?: IBavelPayTravelDeleteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.piid = _data["piid"];
            this.senderId = _data["senderId"];
        }
    }

    static fromJS(data: any): BavelPayTravelDeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BavelPayTravelDeleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["piid"] = this.piid;
        data["senderId"] = this.senderId;
        return data;
    }
}

export interface IBavelPayTravelDeleteRequest {
    piid?: string;
    senderId?: string | undefined;

    [key: string]: any;
}

export class BavelPayTravelDeleteResponse implements IBavelPayTravelDeleteResponse {
    isSuccess?: boolean;
    errorMessage?: string | undefined;

    [key: string]: any;

    constructor(data?: IBavelPayTravelDeleteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.isSuccess = _data["isSuccess"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): BavelPayTravelDeleteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BavelPayTravelDeleteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["isSuccess"] = this.isSuccess;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IBavelPayTravelDeleteResponse {
    isSuccess?: boolean;
    errorMessage?: string | undefined;

    [key: string]: any;
}

export class BavelPayTravelFilter implements IBavelPayTravelFilter {
    dateFilter?: FilterItem[] | undefined;
    referenceFilter?: FilterItem[] | undefined;
    payeeFilter?: StringFilterItem[] | undefined;
    statusFilter?: StatusFilterItem[] | undefined;

    [key: string]: any;

    constructor(data?: IBavelPayTravelFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["dateFilter"])) {
                this.dateFilter = [] as any;
                for (let item of _data["dateFilter"])
                    this.dateFilter!.push(FilterItem.fromJS(item));
            }
            if (Array.isArray(_data["referenceFilter"])) {
                this.referenceFilter = [] as any;
                for (let item of _data["referenceFilter"])
                    this.referenceFilter!.push(FilterItem.fromJS(item));
            }
            if (Array.isArray(_data["payeeFilter"])) {
                this.payeeFilter = [] as any;
                for (let item of _data["payeeFilter"])
                    this.payeeFilter!.push(StringFilterItem.fromJS(item));
            }
            if (Array.isArray(_data["statusFilter"])) {
                this.statusFilter = [] as any;
                for (let item of _data["statusFilter"])
                    this.statusFilter!.push(StatusFilterItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BavelPayTravelFilter {
        data = typeof data === 'object' ? data : {};
        let result = new BavelPayTravelFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.dateFilter)) {
            data["dateFilter"] = [];
            for (let item of this.dateFilter)
                data["dateFilter"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.referenceFilter)) {
            data["referenceFilter"] = [];
            for (let item of this.referenceFilter)
                data["referenceFilter"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.payeeFilter)) {
            data["payeeFilter"] = [];
            for (let item of this.payeeFilter)
                data["payeeFilter"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.statusFilter)) {
            data["statusFilter"] = [];
            for (let item of this.statusFilter)
                data["statusFilter"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBavelPayTravelFilter {
    dateFilter?: FilterItem[] | undefined;
    referenceFilter?: FilterItem[] | undefined;
    payeeFilter?: StringFilterItem[] | undefined;
    statusFilter?: StatusFilterItem[] | undefined;

    [key: string]: any;
}

export class BavelPayTravelItem implements IBavelPayTravelItem {
    id?: string | undefined;
    formOfPayment?: FormOfPayment;
    status?: PaymentStatus;
    currency?: string | undefined;
    partnerId?: string | undefined;
    amount?: number;
    payeeName?: string | undefined;
    payeeEmail?: string | undefined;
    payeeId?: string | undefined;
    payerId?: string | undefined;
    effectiveDate?: Date;
    bookings?: Booking[] | undefined;
    invoices?: Invoice[] | undefined;
    isEditable?: boolean;
    isCancellable?: boolean;
    canResendNotifications?: boolean;
    travellerName?: string | undefined;

    [key: string]: any;

    constructor(data?: IBavelPayTravelItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.formOfPayment = _data["formOfPayment"];
            this.status = _data["status"];
            this.currency = _data["currency"];
            this.partnerId = _data["partnerId"];
            this.amount = _data["amount"];
            this.payeeName = _data["payeeName"];
            this.payeeEmail = _data["payeeEmail"];
            this.payeeId = _data["payeeId"];
            this.payerId = _data["payerId"];
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : undefined as any;
            if (Array.isArray(_data["bookings"])) {
                this.bookings = [] as any;
                for (let item of _data["bookings"])
                    this.bookings!.push(Booking.fromJS(item));
            }
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices!.push(Invoice.fromJS(item));
            }
            this.isEditable = _data["isEditable"];
            this.isCancellable = _data["isCancellable"];
            this.canResendNotifications = _data["canResendNotifications"];
            this.travellerName = _data["travellerName"];
        }
    }

    static fromJS(data: any): BavelPayTravelItem {
        data = typeof data === 'object' ? data : {};
        let result = new BavelPayTravelItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["formOfPayment"] = this.formOfPayment;
        data["status"] = this.status;
        data["currency"] = this.currency;
        data["partnerId"] = this.partnerId;
        data["amount"] = this.amount;
        data["payeeName"] = this.payeeName;
        data["payeeEmail"] = this.payeeEmail;
        data["payeeId"] = this.payeeId;
        data["payerId"] = this.payerId;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : undefined as any;
        if (Array.isArray(this.bookings)) {
            data["bookings"] = [];
            for (let item of this.bookings)
                data["bookings"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item ? item.toJSON() : undefined as any);
        }
        data["isEditable"] = this.isEditable;
        data["isCancellable"] = this.isCancellable;
        data["canResendNotifications"] = this.canResendNotifications;
        data["travellerName"] = this.travellerName;
        return data;
    }
}

export interface IBavelPayTravelItem {
    id?: string | undefined;
    formOfPayment?: FormOfPayment;
    status?: PaymentStatus;
    currency?: string | undefined;
    partnerId?: string | undefined;
    amount?: number;
    payeeName?: string | undefined;
    payeeEmail?: string | undefined;
    payeeId?: string | undefined;
    payerId?: string | undefined;
    effectiveDate?: Date;
    bookings?: Booking[] | undefined;
    invoices?: Invoice[] | undefined;
    isEditable?: boolean;
    isCancellable?: boolean;
    canResendNotifications?: boolean;
    travellerName?: string | undefined;

    [key: string]: any;
}

export class BavelPayTravelNewVccCardRequest implements IBavelPayTravelNewVccCardRequest {
    currency!: string | undefined;
    amount!: number;
    scheme!: string | undefined;
    subScheme?: string | undefined;
    type!: string | undefined;
    partner!: string | undefined;
    startDate?: Date;
    endDate?: Date;
    bookingReference?: string | undefined;
    checkInDate?: Date;
    checkOutDate?: Date;
    bookingGuestFirstName?: string | undefined;
    bookingGuestLastName?: string | undefined;
    supplierType?: string | undefined;
    employeeId?: string | undefined;
    costCentre?: string | undefined;
    ticketNumber?: string | undefined;
    travellerName?: string | undefined;

    [key: string]: any;

    constructor(data?: IBavelPayTravelNewVccCardRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.currency = _data["currency"];
            this.amount = _data["amount"];
            this.scheme = _data["scheme"];
            this.subScheme = _data["subScheme"];
            this.type = _data["type"];
            this.partner = _data["partner"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.bookingReference = _data["bookingReference"];
            this.checkInDate = _data["checkInDate"] ? new Date(_data["checkInDate"].toString()) : undefined as any;
            this.checkOutDate = _data["checkOutDate"] ? new Date(_data["checkOutDate"].toString()) : undefined as any;
            this.bookingGuestFirstName = _data["bookingGuestFirstName"];
            this.bookingGuestLastName = _data["bookingGuestLastName"];
            this.supplierType = _data["supplierType"];
            this.employeeId = _data["employeeId"];
            this.costCentre = _data["costCentre"];
            this.ticketNumber = _data["ticketNumber"];
            this.travellerName = _data["travellerName"];
        }
    }

    static fromJS(data: any): BavelPayTravelNewVccCardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BavelPayTravelNewVccCardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["currency"] = this.currency;
        data["amount"] = this.amount;
        data["scheme"] = this.scheme;
        data["subScheme"] = this.subScheme;
        data["type"] = this.type;
        data["partner"] = this.partner;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["bookingReference"] = this.bookingReference;
        data["checkInDate"] = this.checkInDate ? this.checkInDate.toISOString() : undefined as any;
        data["checkOutDate"] = this.checkOutDate ? this.checkOutDate.toISOString() : undefined as any;
        data["bookingGuestFirstName"] = this.bookingGuestFirstName;
        data["bookingGuestLastName"] = this.bookingGuestLastName;
        data["supplierType"] = this.supplierType;
        data["employeeId"] = this.employeeId;
        data["costCentre"] = this.costCentre;
        data["ticketNumber"] = this.ticketNumber;
        data["travellerName"] = this.travellerName;
        return data;
    }
}

export interface IBavelPayTravelNewVccCardRequest {
    currency: string | undefined;
    amount: number;
    scheme: string | undefined;
    subScheme?: string | undefined;
    type: string | undefined;
    partner: string | undefined;
    startDate?: Date;
    endDate?: Date;
    bookingReference?: string | undefined;
    checkInDate?: Date;
    checkOutDate?: Date;
    bookingGuestFirstName?: string | undefined;
    bookingGuestLastName?: string | undefined;
    supplierType?: string | undefined;
    employeeId?: string | undefined;
    costCentre?: string | undefined;
    ticketNumber?: string | undefined;
    travellerName?: string | undefined;

    [key: string]: any;
}

export class BavelPayTravelNewVccCardResponse implements IBavelPayTravelNewVccCardResponse {
    pan?: string | undefined;
    startDate?: Date;
    endDate?: string | undefined;
    expDate?: string | undefined;
    cvv?: string | undefined;
    partner?: string | undefined;
    type?: string | undefined;
    scheme?: string | undefined;
    subScheme?: string | undefined;
    currency?: string | undefined;
    amount?: number;

    [key: string]: any;

    constructor(data?: IBavelPayTravelNewVccCardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.pan = _data["pan"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"];
            this.expDate = _data["expDate"];
            this.cvv = _data["cvv"];
            this.partner = _data["partner"];
            this.type = _data["type"];
            this.scheme = _data["scheme"];
            this.subScheme = _data["subScheme"];
            this.currency = _data["currency"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): BavelPayTravelNewVccCardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BavelPayTravelNewVccCardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["pan"] = this.pan;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate;
        data["expDate"] = this.expDate;
        data["cvv"] = this.cvv;
        data["partner"] = this.partner;
        data["type"] = this.type;
        data["scheme"] = this.scheme;
        data["subScheme"] = this.subScheme;
        data["currency"] = this.currency;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IBavelPayTravelNewVccCardResponse {
    pan?: string | undefined;
    startDate?: Date;
    endDate?: string | undefined;
    expDate?: string | undefined;
    cvv?: string | undefined;
    partner?: string | undefined;
    type?: string | undefined;
    scheme?: string | undefined;
    subScheme?: string | undefined;
    currency?: string | undefined;
    amount?: number;

    [key: string]: any;
}

export class BavelPayTravelNewVccReferenceResponse implements IBavelPayTravelNewVccReferenceResponse {
    bookingReference?: string | undefined;
    checkInDate?: Date | undefined;
    checkOutDate?: Date | undefined;
    guestFirstName?: string | undefined;
    guestLastName?: string | undefined;

    [key: string]: any;

    constructor(data?: IBavelPayTravelNewVccReferenceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.bookingReference = _data["bookingReference"];
            this.checkInDate = _data["checkInDate"] ? new Date(_data["checkInDate"].toString()) : undefined as any;
            this.checkOutDate = _data["checkOutDate"] ? new Date(_data["checkOutDate"].toString()) : undefined as any;
            this.guestFirstName = _data["guestFirstName"];
            this.guestLastName = _data["guestLastName"];
        }
    }

    static fromJS(data: any): BavelPayTravelNewVccReferenceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BavelPayTravelNewVccReferenceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["bookingReference"] = this.bookingReference;
        data["checkInDate"] = this.checkInDate ? this.checkInDate.toISOString() : undefined as any;
        data["checkOutDate"] = this.checkOutDate ? this.checkOutDate.toISOString() : undefined as any;
        data["guestFirstName"] = this.guestFirstName;
        data["guestLastName"] = this.guestLastName;
        return data;
    }
}

export interface IBavelPayTravelNewVccReferenceResponse {
    bookingReference?: string | undefined;
    checkInDate?: Date | undefined;
    checkOutDate?: Date | undefined;
    guestFirstName?: string | undefined;
    guestLastName?: string | undefined;

    [key: string]: any;
}

export class BavelPayTravelNewVccResponse implements IBavelPayTravelNewVccResponse {
    isSuccess?: boolean;
    statusCode?: string | undefined;
    description?: string | undefined;
    errorCode?: string | undefined;
    secondaryErrorCode?: string | undefined;
    errorMessage?: string | undefined;
    card?: BavelPayTravelNewVccCardResponse;
    references?: BavelPayTravelNewVccReferenceResponse;
    piid?: string | undefined;
    supplierType?: string | undefined;
    employeeId?: string | undefined;
    costCentre?: string | undefined;
    ticketNumber?: string | undefined;
    travellerName?: string | undefined;

    [key: string]: any;

    constructor(data?: IBavelPayTravelNewVccResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.isSuccess = _data["isSuccess"];
            this.statusCode = _data["statusCode"];
            this.description = _data["description"];
            this.errorCode = _data["errorCode"];
            this.secondaryErrorCode = _data["secondaryErrorCode"];
            this.errorMessage = _data["errorMessage"];
            this.card = _data["card"] ? BavelPayTravelNewVccCardResponse.fromJS(_data["card"]) : undefined as any;
            this.references = _data["references"] ? BavelPayTravelNewVccReferenceResponse.fromJS(_data["references"]) : undefined as any;
            this.piid = _data["piid"];
            this.supplierType = _data["supplierType"];
            this.employeeId = _data["employeeId"];
            this.costCentre = _data["costCentre"];
            this.ticketNumber = _data["ticketNumber"];
            this.travellerName = _data["travellerName"];
        }
    }

    static fromJS(data: any): BavelPayTravelNewVccResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BavelPayTravelNewVccResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["isSuccess"] = this.isSuccess;
        data["statusCode"] = this.statusCode;
        data["description"] = this.description;
        data["errorCode"] = this.errorCode;
        data["secondaryErrorCode"] = this.secondaryErrorCode;
        data["errorMessage"] = this.errorMessage;
        data["card"] = this.card ? this.card.toJSON() : undefined as any;
        data["references"] = this.references ? this.references.toJSON() : undefined as any;
        data["piid"] = this.piid;
        data["supplierType"] = this.supplierType;
        data["employeeId"] = this.employeeId;
        data["costCentre"] = this.costCentre;
        data["ticketNumber"] = this.ticketNumber;
        data["travellerName"] = this.travellerName;
        return data;
    }
}

export interface IBavelPayTravelNewVccResponse {
    isSuccess?: boolean;
    statusCode?: string | undefined;
    description?: string | undefined;
    errorCode?: string | undefined;
    secondaryErrorCode?: string | undefined;
    errorMessage?: string | undefined;
    card?: BavelPayTravelNewVccCardResponse;
    references?: BavelPayTravelNewVccReferenceResponse;
    piid?: string | undefined;
    supplierType?: string | undefined;
    employeeId?: string | undefined;
    costCentre?: string | undefined;
    ticketNumber?: string | undefined;
    travellerName?: string | undefined;

    [key: string]: any;
}

export class BavelPayTravelSearchResult implements IBavelPayTravelSearchResult {
    data?: BavelPayTravelItem[] | undefined;
    total?: number;

    [key: string]: any;

    constructor(data?: IBavelPayTravelSearchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(BavelPayTravelItem.fromJS(item));
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): BavelPayTravelSearchResult {
        data = typeof data === 'object' ? data : {};
        let result = new BavelPayTravelSearchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["total"] = this.total;
        return data;
    }
}

export interface IBavelPayTravelSearchResult {
    data?: BavelPayTravelItem[] | undefined;
    total?: number;

    [key: string]: any;
}

export class BavelPayTravelUpdateRequest implements IBavelPayTravelUpdateRequest {
    piid?: string;
    senderId?: string | undefined;
    effectiveMinDate?: Date | undefined;
    effectiveMaxDate?: Date | undefined;
    amount?: number | undefined;
    bookings?: PIBooking[] | undefined;
    comments?: string | undefined;
    supplierType?: string | undefined;
    employeeId?: string | undefined;
    costCentre?: string | undefined;
    travellerName?: string | undefined;
    startDate?: Date | undefined;
    ticketNumber?: string | undefined;

    [key: string]: any;

    constructor(data?: IBavelPayTravelUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.piid = _data["piid"];
            this.senderId = _data["senderId"];
            this.effectiveMinDate = _data["effectiveMinDate"] ? new Date(_data["effectiveMinDate"].toString()) : undefined as any;
            this.effectiveMaxDate = _data["effectiveMaxDate"] ? new Date(_data["effectiveMaxDate"].toString()) : undefined as any;
            this.amount = _data["amount"];
            if (Array.isArray(_data["bookings"])) {
                this.bookings = [] as any;
                for (let item of _data["bookings"])
                    this.bookings!.push(PIBooking.fromJS(item));
            }
            this.comments = _data["comments"];
            this.supplierType = _data["supplierType"];
            this.employeeId = _data["employeeId"];
            this.costCentre = _data["costCentre"];
            this.travellerName = _data["travellerName"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.ticketNumber = _data["ticketNumber"];
        }
    }

    static fromJS(data: any): BavelPayTravelUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BavelPayTravelUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["piid"] = this.piid;
        data["senderId"] = this.senderId;
        data["effectiveMinDate"] = this.effectiveMinDate ? this.effectiveMinDate.toISOString() : undefined as any;
        data["effectiveMaxDate"] = this.effectiveMaxDate ? this.effectiveMaxDate.toISOString() : undefined as any;
        data["amount"] = this.amount;
        if (Array.isArray(this.bookings)) {
            data["bookings"] = [];
            for (let item of this.bookings)
                data["bookings"].push(item ? item.toJSON() : undefined as any);
        }
        data["comments"] = this.comments;
        data["supplierType"] = this.supplierType;
        data["employeeId"] = this.employeeId;
        data["costCentre"] = this.costCentre;
        data["travellerName"] = this.travellerName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["ticketNumber"] = this.ticketNumber;
        return data;
    }
}

export interface IBavelPayTravelUpdateRequest {
    piid?: string;
    senderId?: string | undefined;
    effectiveMinDate?: Date | undefined;
    effectiveMaxDate?: Date | undefined;
    amount?: number | undefined;
    bookings?: PIBooking[] | undefined;
    comments?: string | undefined;
    supplierType?: string | undefined;
    employeeId?: string | undefined;
    costCentre?: string | undefined;
    travellerName?: string | undefined;
    startDate?: Date | undefined;
    ticketNumber?: string | undefined;

    [key: string]: any;
}

export class BavelPayTravelUpdateResponse implements IBavelPayTravelUpdateResponse {
    isSuccess?: boolean;
    errorMessage?: string | undefined;

    [key: string]: any;

    constructor(data?: IBavelPayTravelUpdateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.isSuccess = _data["isSuccess"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): BavelPayTravelUpdateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BavelPayTravelUpdateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["isSuccess"] = this.isSuccess;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IBavelPayTravelUpdateResponse {
    isSuccess?: boolean;
    errorMessage?: string | undefined;

    [key: string]: any;
}

export class BillTo implements IBillTo {
    companyName?: string | undefined;
    taxId?: string | undefined;
    address?: string | undefined;
    postalCode?: string | undefined;
    cityName?: string | undefined;
    regionCode?: string | undefined;
    countryIso?: string | undefined;
    emailAddress?: string | undefined;

    [key: string]: any;

    constructor(data?: IBillTo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.companyName = _data["companyName"];
            this.taxId = _data["taxId"];
            this.address = _data["address"];
            this.postalCode = _data["postalCode"];
            this.cityName = _data["cityName"];
            this.regionCode = _data["regionCode"];
            this.countryIso = _data["countryIso"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): BillTo {
        data = typeof data === 'object' ? data : {};
        let result = new BillTo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["companyName"] = this.companyName;
        data["taxId"] = this.taxId;
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        data["cityName"] = this.cityName;
        data["regionCode"] = this.regionCode;
        data["countryIso"] = this.countryIso;
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface IBillTo {
    companyName?: string | undefined;
    taxId?: string | undefined;
    address?: string | undefined;
    postalCode?: string | undefined;
    cityName?: string | undefined;
    regionCode?: string | undefined;
    countryIso?: string | undefined;
    emailAddress?: string | undefined;

    [key: string]: any;
}

export class Booking implements IBooking {
    reference?: string | undefined;
    supplierReference?: string | undefined;
    checkIn?: Date;
    checkOut?: Date;
    guests?: Guest[] | undefined;

    [key: string]: any;

    constructor(data?: IBooking) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.reference = _data["reference"];
            this.supplierReference = _data["supplierReference"];
            this.checkIn = _data["checkIn"] ? new Date(_data["checkIn"].toString()) : undefined as any;
            this.checkOut = _data["checkOut"] ? new Date(_data["checkOut"].toString()) : undefined as any;
            if (Array.isArray(_data["guests"])) {
                this.guests = [] as any;
                for (let item of _data["guests"])
                    this.guests!.push(Guest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Booking {
        data = typeof data === 'object' ? data : {};
        let result = new Booking();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["reference"] = this.reference;
        data["supplierReference"] = this.supplierReference;
        data["checkIn"] = this.checkIn ? this.checkIn.toISOString() : undefined as any;
        data["checkOut"] = this.checkOut ? this.checkOut.toISOString() : undefined as any;
        if (Array.isArray(this.guests)) {
            data["guests"] = [];
            for (let item of this.guests)
                data["guests"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBooking {
    reference?: string | undefined;
    supplierReference?: string | undefined;
    checkIn?: Date;
    checkOut?: Date;
    guests?: Guest[] | undefined;

    [key: string]: any;
}

export class Card implements ICard {
    cardScheme?: number;
    cardType?: number;
    expiryDate?: string | undefined;
    cvv?: string | undefined;
    pan?: string | undefined;
    cardHolder?: string | undefined;

    [key: string]: any;

    constructor(data?: ICard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.cardScheme = _data["cardScheme"];
            this.cardType = _data["cardType"];
            this.expiryDate = _data["expiryDate"];
            this.cvv = _data["cvv"];
            this.pan = _data["pan"];
            this.cardHolder = _data["cardHolder"];
        }
    }

    static fromJS(data: any): Card {
        data = typeof data === 'object' ? data : {};
        let result = new Card();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["cardScheme"] = this.cardScheme;
        data["cardType"] = this.cardType;
        data["expiryDate"] = this.expiryDate;
        data["cvv"] = this.cvv;
        data["pan"] = this.pan;
        data["cardHolder"] = this.cardHolder;
        return data;
    }
}

export interface ICard {
    cardScheme?: number;
    cardType?: number;
    expiryDate?: string | undefined;
    cvv?: string | undefined;
    pan?: string | undefined;
    cardHolder?: string | undefined;

    [key: string]: any;
}

export enum CommunicationType {
    RegistrationVoucher = "RegistrationVoucher",
    LinkToPayment = "LinkToPayment",
    LoginActivation = "LoginActivation",
    PaymentCreationConfirmation = "PaymentCreationConfirmation",
}

export class DefaulterPayeeResponse implements IDefaulterPayeeResponse {
    isDefaulter!: boolean;

    [key: string]: any;

    constructor(data?: IDefaulterPayeeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.isDefaulter = _data["isDefaulter"];
        }
    }

    static fromJS(data: any): DefaulterPayeeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DefaulterPayeeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["isDefaulter"] = this.isDefaulter;
        return data;
    }
}

export interface IDefaulterPayeeResponse {
    isDefaulter: boolean;

    [key: string]: any;
}

export class FeatureToggleResponse implements IFeatureToggleResponse {
    enabled?: boolean;

    [key: string]: any;

    constructor(data?: IFeatureToggleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): FeatureToggleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureToggleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["enabled"] = this.enabled;
        return data;
    }
}

export interface IFeatureToggleResponse {
    enabled?: boolean;

    [key: string]: any;
}

export class FilterItem implements IFilterItem {
    value!: number;
    label!: string | undefined;

    [key: string]: any;

    constructor(data?: IFilterItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.value = _data["value"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): FilterItem {
        data = typeof data === 'object' ? data : {};
        let result = new FilterItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["value"] = this.value;
        data["label"] = this.label;
        return data;
    }
}

export interface IFilterItem {
    value: number;
    label: string | undefined;

    [key: string]: any;
}

export enum FormOfPayment {
    NotDefined = "NotDefined",
    VirtualCard = "VirtualCard",
    BankTransfer = "BankTransfer",
    CreditCard = "CreditCard",
}

export class FullTrack implements IFullTrack {
    cardHolder?: string | undefined;
    cvv?: string | undefined;
    expiryDate?: string | undefined;
    pan?: string | undefined;

    [key: string]: any;

    constructor(data?: IFullTrack) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.cardHolder = _data["cardHolder"];
            this.cvv = _data["cvv"];
            this.expiryDate = _data["expiryDate"];
            this.pan = _data["pan"];
        }
    }

    static fromJS(data: any): FullTrack {
        data = typeof data === 'object' ? data : {};
        let result = new FullTrack();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["cardHolder"] = this.cardHolder;
        data["cvv"] = this.cvv;
        data["expiryDate"] = this.expiryDate;
        data["pan"] = this.pan;
        return data;
    }
}

export interface IFullTrack {
    cardHolder?: string | undefined;
    cvv?: string | undefined;
    expiryDate?: string | undefined;
    pan?: string | undefined;

    [key: string]: any;
}

export class Guest implements IGuest {
    title?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;

    [key: string]: any;

    constructor(data?: IGuest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.title = _data["title"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): Guest {
        data = typeof data === 'object' ? data : {};
        let result = new Guest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["title"] = this.title;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        return data;
    }
}

export interface IGuest {
    title?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;

    [key: string]: any;
}

export class HasPersonalInformation implements IHasPersonalInformation {
    firstName?: ValidatedValue;
    firstSurname?: ValidatedValue;
    secondSurname?: ValidatedValue;
    termsAccepted?: boolean;
    completed?: boolean;

    [key: string]: any;

    constructor(data?: IHasPersonalInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.firstName = _data["firstName"] ? ValidatedValue.fromJS(_data["firstName"]) : undefined as any;
            this.firstSurname = _data["firstSurname"] ? ValidatedValue.fromJS(_data["firstSurname"]) : undefined as any;
            this.secondSurname = _data["secondSurname"] ? ValidatedValue.fromJS(_data["secondSurname"]) : undefined as any;
            this.termsAccepted = _data["termsAccepted"];
            this.completed = _data["completed"];
        }
    }

    static fromJS(data: any): HasPersonalInformation {
        data = typeof data === 'object' ? data : {};
        let result = new HasPersonalInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["firstName"] = this.firstName ? this.firstName.toJSON() : undefined as any;
        data["firstSurname"] = this.firstSurname ? this.firstSurname.toJSON() : undefined as any;
        data["secondSurname"] = this.secondSurname ? this.secondSurname.toJSON() : undefined as any;
        data["termsAccepted"] = this.termsAccepted;
        data["completed"] = this.completed;
        return data;
    }
}

export interface IHasPersonalInformation {
    firstName?: ValidatedValue;
    firstSurname?: ValidatedValue;
    secondSurname?: ValidatedValue;
    termsAccepted?: boolean;
    completed?: boolean;

    [key: string]: any;
}

export class Invoice implements IInvoice {
    reference?: string | undefined;

    [key: string]: any;

    constructor(data?: IInvoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.reference = _data["reference"];
        }
    }

    static fromJS(data: any): Invoice {
        data = typeof data === 'object' ? data : {};
        let result = new Invoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["reference"] = this.reference;
        return data;
    }
}

export interface IInvoice {
    reference?: string | undefined;

    [key: string]: any;
}

export class NotificationRequest implements INotificationRequest {
    piid?: string | undefined;
    emails?: string[] | undefined;
    sendAsTestNotification?: boolean;

    [key: string]: any;

    constructor(data?: INotificationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.piid = _data["piid"];
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(item);
            }
            this.sendAsTestNotification = _data["sendAsTestNotification"];
        }
    }

    static fromJS(data: any): NotificationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["piid"] = this.piid;
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item);
        }
        data["sendAsTestNotification"] = this.sendAsTestNotification;
        return data;
    }
}

export interface INotificationRequest {
    piid?: string | undefined;
    emails?: string[] | undefined;
    sendAsTestNotification?: boolean;

    [key: string]: any;
}

export enum NotificationType {
    Manual = "Manual",
    Automatic = "Automatic",
}

export class PaymentDetailResponse implements IPaymentDetailResponse {
    piid?: string | undefined;
    payeeEmail?: string | undefined;
    settledPaymentInvoiceStatus?: SettlementInvoiceStatus;
    billTo?: BillTo;
    status?: number;
    card?: Card;
    bookings?: PIBooking[] | undefined;
    invoices?: PIInvoice[] | undefined;
    processingRules?: ProcessingRules;
    effectiveMinDate?: Date | undefined;
    effectiveMaxDate?: Date | undefined;
    currency?: string | undefined;
    amount?: number | undefined;
    comments?: string | undefined;
    senderName?: string | undefined;
    payerName?: string | undefined;
    payerId?: string | undefined;
    formOfPayment?: FormOfPayment;
    supplierType?: string | undefined;
    employeeId?: string | undefined;
    costCentre?: string | undefined;
    ticketNumber?: string | undefined;
    travellerName?: string | undefined;
    startDate?: string | undefined;

    [key: string]: any;

    constructor(data?: IPaymentDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.piid = _data["piid"];
            this.payeeEmail = _data["payeeEmail"];
            this.settledPaymentInvoiceStatus = _data["settledPaymentInvoiceStatus"];
            this.billTo = _data["billTo"] ? BillTo.fromJS(_data["billTo"]) : undefined as any;
            this.status = _data["status"];
            this.card = _data["card"] ? Card.fromJS(_data["card"]) : undefined as any;
            if (Array.isArray(_data["bookings"])) {
                this.bookings = [] as any;
                for (let item of _data["bookings"])
                    this.bookings!.push(PIBooking.fromJS(item));
            }
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices!.push(PIInvoice.fromJS(item));
            }
            this.processingRules = _data["processingRules"] ? ProcessingRules.fromJS(_data["processingRules"]) : undefined as any;
            this.effectiveMinDate = _data["effectiveMinDate"] ? new Date(_data["effectiveMinDate"].toString()) : undefined as any;
            this.effectiveMaxDate = _data["effectiveMaxDate"] ? new Date(_data["effectiveMaxDate"].toString()) : undefined as any;
            this.currency = _data["currency"];
            this.amount = _data["amount"];
            this.comments = _data["comments"];
            this.senderName = _data["senderName"];
            this.payerName = _data["payerName"];
            this.payerId = _data["payerId"];
            this.formOfPayment = _data["formOfPayment"];
            this.supplierType = _data["supplierType"];
            this.employeeId = _data["employeeId"];
            this.costCentre = _data["costCentre"];
            this.ticketNumber = _data["ticketNumber"];
            this.travellerName = _data["travellerName"];
            this.startDate = _data["startDate"];
        }
    }

    static fromJS(data: any): PaymentDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["piid"] = this.piid;
        data["payeeEmail"] = this.payeeEmail;
        data["settledPaymentInvoiceStatus"] = this.settledPaymentInvoiceStatus;
        data["billTo"] = this.billTo ? this.billTo.toJSON() : undefined as any;
        data["status"] = this.status;
        data["card"] = this.card ? this.card.toJSON() : undefined as any;
        if (Array.isArray(this.bookings)) {
            data["bookings"] = [];
            for (let item of this.bookings)
                data["bookings"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item ? item.toJSON() : undefined as any);
        }
        data["processingRules"] = this.processingRules ? this.processingRules.toJSON() : undefined as any;
        data["effectiveMinDate"] = this.effectiveMinDate ? this.effectiveMinDate.toISOString() : undefined as any;
        data["effectiveMaxDate"] = this.effectiveMaxDate ? this.effectiveMaxDate.toISOString() : undefined as any;
        data["currency"] = this.currency;
        data["amount"] = this.amount;
        data["comments"] = this.comments;
        data["senderName"] = this.senderName;
        data["payerName"] = this.payerName;
        data["payerId"] = this.payerId;
        data["formOfPayment"] = this.formOfPayment;
        data["supplierType"] = this.supplierType;
        data["employeeId"] = this.employeeId;
        data["costCentre"] = this.costCentre;
        data["ticketNumber"] = this.ticketNumber;
        data["travellerName"] = this.travellerName;
        data["startDate"] = this.startDate;
        return data;
    }
}

export interface IPaymentDetailResponse {
    piid?: string | undefined;
    payeeEmail?: string | undefined;
    settledPaymentInvoiceStatus?: SettlementInvoiceStatus;
    billTo?: BillTo;
    status?: number;
    card?: Card;
    bookings?: PIBooking[] | undefined;
    invoices?: PIInvoice[] | undefined;
    processingRules?: ProcessingRules;
    effectiveMinDate?: Date | undefined;
    effectiveMaxDate?: Date | undefined;
    currency?: string | undefined;
    amount?: number | undefined;
    comments?: string | undefined;
    senderName?: string | undefined;
    payerName?: string | undefined;
    payerId?: string | undefined;
    formOfPayment?: FormOfPayment;
    supplierType?: string | undefined;
    employeeId?: string | undefined;
    costCentre?: string | undefined;
    ticketNumber?: string | undefined;
    travellerName?: string | undefined;
    startDate?: string | undefined;

    [key: string]: any;
}

export class PaymentNotification implements IPaymentNotification {
    sentAt?: Date;
    emailTo?: string | undefined;
    communicationType?: CommunicationType2 | undefined;
    type?: Type | undefined;

    [key: string]: any;

    constructor(data?: IPaymentNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.sentAt = _data["sentAt"] ? new Date(_data["sentAt"].toString()) : undefined as any;
            this.emailTo = _data["emailTo"];
            this.communicationType = _data["communicationType"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): PaymentNotification {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["sentAt"] = this.sentAt ? this.sentAt.toISOString() : undefined as any;
        data["emailTo"] = this.emailTo;
        data["communicationType"] = this.communicationType;
        data["type"] = this.type;
        return data;
    }
}

export interface IPaymentNotification {
    sentAt?: Date;
    emailTo?: string | undefined;
    communicationType?: CommunicationType2 | undefined;
    type?: Type | undefined;

    [key: string]: any;
}

export class PaymentNotifications implements IPaymentNotifications {
    notifications?: PaymentNotification[] | undefined;

    [key: string]: any;

    constructor(data?: IPaymentNotifications) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [] as any;
                for (let item of _data["notifications"])
                    this.notifications!.push(PaymentNotification.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaymentNotifications {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentNotifications();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPaymentNotifications {
    notifications?: PaymentNotification[] | undefined;

    [key: string]: any;
}

export enum PaymentStatus {
    NotDefined = "NotDefined",
    Inactive = "Inactive",
    Active = "Active",
    Cancelled = "Cancelled",
    Expired = "Expired",
    Processed = "Processed",
    Submitted = "Submitted",
    Settled = "Settled",
    Error = "Error",
    PendingInvoice = "PendingInvoice",
    Pending = "Pending",
}

export class PersonalInformationRequest implements IPersonalInformationRequest {
    firstName?: string | undefined;
    firstSurname?: string | undefined;
    secondSurname?: string | undefined;
    termsAccepted?: boolean;

    [key: string]: any;

    constructor(data?: IPersonalInformationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.firstName = _data["firstName"];
            this.firstSurname = _data["firstSurname"];
            this.secondSurname = _data["secondSurname"];
            this.termsAccepted = _data["termsAccepted"];
        }
    }

    static fromJS(data: any): PersonalInformationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PersonalInformationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["firstName"] = this.firstName;
        data["firstSurname"] = this.firstSurname;
        data["secondSurname"] = this.secondSurname;
        data["termsAccepted"] = this.termsAccepted;
        return data;
    }
}

export interface IPersonalInformationRequest {
    firstName?: string | undefined;
    firstSurname?: string | undefined;
    secondSurname?: string | undefined;
    termsAccepted?: boolean;

    [key: string]: any;
}

export class PIBooking implements IPIBooking {
    /** Identificador del Booking */
    reference?: string | undefined;
    /** CheckinDate */
    checkinDate?: Date | undefined;
    /** CheckinDate */
    checkoutDate?: Date | undefined;
    /** Guests */
    guests?: Guest[] | undefined;

    [key: string]: any;

    constructor(data?: IPIBooking) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.reference = _data["reference"];
            this.checkinDate = _data["checkinDate"] ? new Date(_data["checkinDate"].toString()) : undefined as any;
            this.checkoutDate = _data["checkoutDate"] ? new Date(_data["checkoutDate"].toString()) : undefined as any;
            if (Array.isArray(_data["guests"])) {
                this.guests = [] as any;
                for (let item of _data["guests"])
                    this.guests!.push(Guest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PIBooking {
        data = typeof data === 'object' ? data : {};
        let result = new PIBooking();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["reference"] = this.reference;
        data["checkinDate"] = this.checkinDate ? this.checkinDate.toISOString() : undefined as any;
        data["checkoutDate"] = this.checkoutDate ? this.checkoutDate.toISOString() : undefined as any;
        if (Array.isArray(this.guests)) {
            data["guests"] = [];
            for (let item of this.guests)
                data["guests"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPIBooking {
    /** Identificador del Booking */
    reference?: string | undefined;
    /** CheckinDate */
    checkinDate?: Date | undefined;
    /** CheckinDate */
    checkoutDate?: Date | undefined;
    /** Guests */
    guests?: Guest[] | undefined;

    [key: string]: any;
}

export class PIInvoice implements IPIInvoice {
    /** Identificador de la invoice */
    reference?: string | undefined;
    /** Invoice date */
    date?: Date | undefined;

    [key: string]: any;

    constructor(data?: IPIInvoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.reference = _data["reference"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PIInvoice {
        data = typeof data === 'object' ? data : {};
        let result = new PIInvoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["reference"] = this.reference;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        return data;
    }
}

export interface IPIInvoice {
    /** Identificador de la invoice */
    reference?: string | undefined;
    /** Invoice date */
    date?: Date | undefined;

    [key: string]: any;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class ProcessingRules implements IProcessingRules {
    fullCredit?: boolean | undefined;
    services?: string | undefined;
    invoiceRequired?: boolean | undefined;
    authorizedCharges?: string | undefined;
    restrictions?: string | undefined;

    [key: string]: any;

    constructor(data?: IProcessingRules) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.fullCredit = _data["fullCredit"];
            this.services = _data["services"];
            this.invoiceRequired = _data["invoiceRequired"];
            this.authorizedCharges = _data["authorizedCharges"];
            this.restrictions = _data["restrictions"];
        }
    }

    static fromJS(data: any): ProcessingRules {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessingRules();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["fullCredit"] = this.fullCredit;
        data["services"] = this.services;
        data["invoiceRequired"] = this.invoiceRequired;
        data["authorizedCharges"] = this.authorizedCharges;
        data["restrictions"] = this.restrictions;
        return data;
    }
}

export interface IProcessingRules {
    fullCredit?: boolean | undefined;
    services?: string | undefined;
    invoiceRequired?: boolean | undefined;
    authorizedCharges?: string | undefined;
    restrictions?: string | undefined;

    [key: string]: any;
}

export enum SettlementInvoiceStatus {
    None = "None",
    MissingRequiredInvoice = "MissingRequiredInvoice",
    Defaulter = "Defaulter",
}

export class StatusFilterItem implements IStatusFilterItem {
    value!: number;
    label!: string | undefined;

    [key: string]: any;

    constructor(data?: IStatusFilterItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.value = _data["value"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): StatusFilterItem {
        data = typeof data === 'object' ? data : {};
        let result = new StatusFilterItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["value"] = this.value;
        data["label"] = this.label;
        return data;
    }
}

export interface IStatusFilterItem {
    value: number;
    label: string | undefined;

    [key: string]: any;
}

export class StringFilterItem implements IStringFilterItem {
    value!: string | undefined;
    label!: string | undefined;

    [key: string]: any;

    constructor(data?: IStringFilterItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.value = _data["value"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): StringFilterItem {
        data = typeof data === 'object' ? data : {};
        let result = new StringFilterItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["value"] = this.value;
        data["label"] = this.label;
        return data;
    }
}

export interface IStringFilterItem {
    value: string | undefined;
    label: string | undefined;

    [key: string]: any;
}

export class UpdatedPersonalInformationResponse implements IUpdatedPersonalInformationResponse {
    isPersonalInformationValid?: boolean;

    [key: string]: any;

    constructor(data?: IUpdatedPersonalInformationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.isPersonalInformationValid = _data["isPersonalInformationValid"];
        }
    }

    static fromJS(data: any): UpdatedPersonalInformationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatedPersonalInformationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["isPersonalInformationValid"] = this.isPersonalInformationValid;
        return data;
    }
}

export interface IUpdatedPersonalInformationResponse {
    isPersonalInformationValid?: boolean;

    [key: string]: any;
}

export class ValidatedValue implements IValidatedValue {
    value!: string | undefined;
    isValid!: boolean;

    [key: string]: any;

    constructor(data?: IValidatedValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.value = _data["value"];
            this.isValid = _data["isValid"];
        }
    }

    static fromJS(data: any): ValidatedValue {
        data = typeof data === 'object' ? data : {};
        let result = new ValidatedValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["value"] = this.value;
        data["isValid"] = this.isValid;
        return data;
    }
}

export interface IValidatedValue {
    value: string | undefined;
    isValid: boolean;

    [key: string]: any;
}

export class VccMoneyAccount implements IVccMoneyAccount {
    currency?: string | undefined;
    id?: string | undefined;
    type?: string | undefined;

    [key: string]: any;

    constructor(data?: IVccMoneyAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.currency = _data["currency"];
            this.id = _data["id"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): VccMoneyAccount {
        data = typeof data === 'object' ? data : {};
        let result = new VccMoneyAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["currency"] = this.currency;
        data["id"] = this.id;
        data["type"] = this.type;
        return data;
    }
}

export interface IVccMoneyAccount {
    currency?: string | undefined;
    id?: string | undefined;
    type?: string | undefined;

    [key: string]: any;
}

export class VccPartner implements IVccPartner {
    id?: number;
    name?: string | undefined;

    [key: string]: any;

    constructor(data?: IVccPartner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): VccPartner {
        data = typeof data === 'object' ? data : {};
        let result = new VccPartner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IVccPartner {
    id?: number;
    name?: string | undefined;

    [key: string]: any;
}

export class VccProfile implements IVccProfile {
    id?: string | undefined;
    scheme?: string | undefined;
    subScheme?: string[] | undefined;

    [key: string]: any;

    constructor(data?: IVccProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.scheme = _data["scheme"];
            if (Array.isArray(_data["subScheme"])) {
                this.subScheme = [] as any;
                for (let item of _data["subScheme"])
                    this.subScheme!.push(item);
            }
        }
    }

    static fromJS(data: any): VccProfile {
        data = typeof data === 'object' ? data : {};
        let result = new VccProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["scheme"] = this.scheme;
        if (Array.isArray(this.subScheme)) {
            data["subScheme"] = [];
            for (let item of this.subScheme)
                data["subScheme"].push(item);
        }
        return data;
    }
}

export interface IVccProfile {
    id?: string | undefined;
    scheme?: string | undefined;
    subScheme?: string[] | undefined;

    [key: string]: any;
}

export class CommunicationType2 implements ICommunicationType2 {

    [key: string]: any;

    constructor(data?: ICommunicationType2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): CommunicationType2 {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationType2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface ICommunicationType2 {

    [key: string]: any;
}

export class Type implements IType {

    [key: string]: any;

    constructor(data?: IType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): Type {
        data = typeof data === 'object' ? data : {};
        let result = new Type();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface IType {

    [key: string]: any;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}